var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOpen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.103,
    height: 9.728,
    viewBox: "0 0 9.103 9.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Composant_41_1",
    "data-name": "Composant 41 \\u2013 1",
    transform: "translate(0 0.141)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "customStroke",
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    transform: "matrix(1, 0.017, -0.017, 1, 0.105, 3.431)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    className: "customFill",
    width: 8.999,
    height: 6,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "customStroke",
    x: 0.1,
    y: 0.1,
    width: 8.799,
    height: 5.8,
    rx: 0.9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    className: "customFill",
    id: "open",
    transform: "translate(0.052 4.5)",
    fill: "#fff",
    fontSize: 3,
    fontFamily: "AauxNext-Medium, Aaux Next",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.651,
    y: 3
  }, "OPEN")), /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    id: "open_-_Contour",
    "data-name": "open - Contour",
    d: "M1.821.829c.561,0,.9.42.9,1.124s-.335,1.124-.9,1.124S.928,2.657.928,1.953,1.262.829,1.821.829Zm0,2.148c.718,0,.8-.716.8-1.024S2.539.929,1.821.929s-.793.716-.793,1.024S1.105,2.977,1.821,2.977ZM2.935.856h.836c.479,0,.743.229.743.644s-.248.641-.737.641h-.5V3.05h-.34Zm.842,1.185c.435,0,.637-.172.637-.541S4.2.956,3.771.956H3.035V2.95h.14V2.041ZM4.684.856H6.146V1.19H5.024v.566h.981v.325H5.024v.635H6.146V3.05H4.684Zm1.362.1H4.784V2.95H6.046V2.816H4.924V1.981H5.9V1.856H4.924V1.09H6.046Zm.369-.1h.3l.93,1.5V.856h.34V3.05H7.688l-.933-1.5v1.5h-.34Zm.241.1H6.515V2.95h.14V1.2L7.744,2.95h.138V.956h-.14V2.711Zm-4.835.11c.429,0,.656.307.656.887s-.227.887-.656.887-.653-.307-.653-.887S1.394,1.066,1.821,1.066Zm0,1.674c.369,0,.556-.265.556-.787s-.187-.787-.556-.787-.553.265-.553.787S1.454,2.74,1.821,2.74ZM3.175,1.087h.59c.219,0,.509.043.509.413,0,.419-.383.419-.509.419h-.59Zm.59.732c.291,0,.409-.092.409-.319s-.118-.313-.409-.313h-.49v.632Z",
    transform: "translate(0.052 4.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    className: "customStroke",
    id: "Ligne_25",
    "data-name": "Ligne 25",
    y1: 4,
    x2: 4,
    transform: "translate(0.552)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "customStroke",
    id: "Ligne_26",
    "data-name": "Ligne 26",
    x1: 4,
    y1: 4,
    transform: "translate(4.552)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpen);
export default __webpack_public_path__ + "static/media/icon-open.e2047e6d84fdc65e57f9ef29f24327d8.svg";
export { ForwardRef as ReactComponent };